import { observable } from "mobx";
import { Model } from "@root/data/lib";
import { ApiAuthTenant } from "../../../api/clients/mbaas/api";

export interface DeserializedAuthTenant extends ApiAuthTenant {
  subscriptionId?: string;
}

export class AuthTenant extends Model<DeserializedAuthTenant> implements DeserializedAuthTenant {
  @observable public id: string;
  @observable public name: string;
  @observable public type?: string;
  @observable public location?: string;
  @observable public subscriptionId?: string;
}
